import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import useViewer from '@hooks/useViewer';

const useConversationParticipants = conversation => {
    const [participant, setParticipant] = useState();
    const [viewerParticipant, setViewerParticipant] = useState();
    const { viewer } = useViewer();
    useEffect(() => {
        (async () => {
            if (!conversation || !viewer) return;
            const fetchedParticipants = await conversation.getParticipants();
            // there will only be one right now
            const notViewerParty = fetchedParticipants.find(p => p.state.identity !== viewer.id);
            const viewerParty = fetchedParticipants.find(p => p.state.identity === viewer.id);
            setParticipant(notViewerParty);
            setViewerParticipant(viewerParty);
        })();
    }, [conversation, viewer]);

    return { participant, viewerParticipant };
};

useConversationParticipants.propTypes = {
    conversation: PropTypes.object,
};

export default useConversationParticipants;
